import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-star",
  "use": "icon-star-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol viewBox=\"0 0 16 16\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-star\">\n<path d=\"M8 0L5.96307 5.94345L0 6.09524L4.79972 9.90476L3.05398 16L8 12.4196L12.946 16L11.2727 9.98065L16 6.09524L9.96307 5.94345L8 0Z\" fill=\"#FFA800\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol